import React from "react"

import {FieldViewProps} from "../../../../render/view"
import FieldViewSmall from "../../../../render/view-small"

export default function FieldStatus_ViewGlist(props: FieldViewProps) {

    return <FieldViewSmall {...props} />
}
